import { PipeTransform, Pipe } from '@angular/core';
import * as joda from '@js-joda/core';

const DATETIME_FORMATTER = joda.DateTimeFormatter.ofPattern('MM/yyyy');

/**
 * Inspired by Angular's own DatePipe, but:
 * 1. Auto-formats to application preferred formats.
 * 2. Supports Joda-time.
 */
@Pipe({
    name: 'myDateMonthYear',
    pure: true
})
export class MyDateMonthYearPipe implements PipeTransform {

    /**
     *
     * @param value a Date, Joda Temporal of some sort, or ISO-8601 date-time
     * @returns {string}
     */
    transform(value: any): string {
        if (!value)
            return null;

        let dt: joda.Temporal;
        let tz = '';

        if (typeof value === 'string') {
            let str = (value as string).trim();
            if (/T.*[Z+-]/.test(str)) {
                // Contains zone ID (by Z, + or - after the date portion)
                dt = joda.ZonedDateTime.parse(str);
            }
            else if (/T.* ...$/.test(str)) {
                // Non-standard Remedi format with ISO Date/Time followed by space & three-char time zone name.
                // Process the date/time, and just tack the zone back on the end.
                dt = joda.LocalDateTime.parse(str.substr(0, str.length-4));
                tz = str.substr(str.length-4);
            }
            else {
                dt = joda.LocalDateTime.parse(str);
            }
        }
        else if (value instanceof Date) {
            let t = joda.Instant.ofEpochMilli((value as Date).getTime());
            dt = joda.ZonedDateTime.ofInstant(t, joda.ZoneId.SYSTEM);
        }
        else if (value instanceof joda.LocalDateTime || value instanceof joda.ZonedDateTime) {
            dt = value;
        }
        else {
            // Unknown object
            return value.toString();
        }

        return DATETIME_FORMATTER.format(dt);
    }
}
